import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react"

import { Tabs, Form, Row, Col, Select, Modal } from 'antd';
import TextArea from '../../../../../ui/TextArea';
import PageContainer from "../../../../../CSIComponents/PageContainer";

import { getOTACodes } from "../../../../../../services/common";

interface optionType {
  codeName: string, 
  codeType: string, 
  codeValue: string, 
  id: number, 
  subCat: string | null
}

const { TabPane } = Tabs;
const { Option } = Select;
let errHandle = false;
let newTabIndex = 0;
const AcceptedPaymentAdd = forwardRef((props: any, acceptedPaymentAddRef: any) => {
  const [form]: any = Form.useForm()
  useImperativeHandle(acceptedPaymentAddRef, () => ({ aceeptedPaymentForm: form, restoreErr: () => { errHandle = false } }))
  let initialPanes = [{ id: '1', name: 'Accepted Payment 1', content: 'Content of new Tab', closable: true }]
  const [activeKey, setActiveKey] = useState(initialPanes[0].id)
  const [panes, setPanels] = useState(initialPanes)
  const [isRequired, setIsRequired] = useState(true)

  const onChange = (activeKey: any) => {
    setActiveKey(activeKey)
  };

  const onEdit = (targetKey: any, action: any) => {
    if (action == 'add') {
      add()
    } else if (action == 'remove') {
      remove(targetKey)
    }
  };

  const add = () => {
    setIsRequired(true)
    const newKey = ++newTabIndex;
    const newPanes = [...panes];
    newPanes.push(
      {
        name: 'Accepted Payment ' + newKey,
        content: 'Content of new Tab',
        id: newKey + '',
        closable: true
      }
    );
    newPanes[0].closable = true;
    setPanels(newPanes)
    setActiveKey(JSON.stringify(newKey))
  };
  const ModalHead = () => {
    return (
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        height: '50px',
        lineHeight: '50px',
        textIndent: '10px',
        borderBottom: '1px solid #ccc',
        color: '#fff',
        background: '#06789D',
        fontSize: 18,
        width: '100%'
      }}>Confirm</div>
    )
  }


  const remove = (targetKey: any) => {
    let deleteTabName = panes.filter((item: any) => targetKey == item.id)
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${deleteTabName[0].name} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      transitionName: '',
      maskTransitionName: '',
      onOk() {
        if (panes.length === 1) {
          form.resetFields()
          setIsRequired(false)
          props.validateFieldsError();
        } else {
          let newActiveKey = activeKey;
          let lastIndex: any;
          panes.forEach((pane: any, i: any) => {
            if (pane.id == targetKey) {
              lastIndex = i - 1;
            }
          });
          const newPanes = panes.filter((pane: any) => pane.id !== targetKey);
          if (newPanes.length && newActiveKey === targetKey) {
            if (lastIndex >= 0) {
              newActiveKey = newPanes[lastIndex].id;
            } else {
              newActiveKey = newPanes[0].id;
            }
          }
          if (newPanes.length === 1) {
            newPanes[0].closable = true;
          }
          setPanels(newPanes)
          setActiveKey(newActiveKey)
        }

      },
      onCancel() {

      },
    });
  };
  const [chgPmtData, setChgPmtData] = useState([])
  const getChgPmtData = async () => {
    let res = await getOTACodes('PMT', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setChgPmtData(res.otacodes)
    } else {
      setChgPmtData([])
    }
  };
  const [chgCrdData, setChgCrdData] = useState([])
  const getChgCrdData = async () => {
    let res = await getOTACodes('CRD', '')
    if (res && res.otacodes && res.otacodes.length != 0) {
      setChgCrdData(res.otacodes)
    } else {
      setChgCrdData([])
    }
  };
  useEffect(() => {
    newTabIndex = panes.length > 0 ? panes.length : 1;
    panes.forEach((item: any, index: any) => {
      form.setFieldsValue({
        [`paymenttype-${item.id}`]: item.paymenttype,
        [`description-${item.id}`]: item.description,

        [`acceptedforguarnatee-${item.id}`]: item.acceptedforguarnatee,
        [`cardtype-${item.id}`]: item.cardtype,
        [`usefordeposit-${item.id}`]: item.usefordeposit,
        [`useforpayment-${item.id}`]: item.useforpayment,
      })
    })
    getChgPmtData();
    getChgCrdData()
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [])

  useEffect(() => {
    if (errHandle) {
      props.validateFieldsError();
    } else {
      errHandle = true;
    }
  }, 
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  [panes])


  return (
    <>
      <PageContainer style={{ marginBottom: '90px' }}>
        <div style={{ background: '#fff', padding: '20px 10px 20px 0' }}>
          <Form
            layout="vertical"
            form={form}
            name="basic"
            //key={newTabIndex + ''}
            onValuesChange={(changedFields, allFields) => {
              setIsRequired(true);
              props.validateFieldsError();
            }}
          // onFinish={() => console.log('finish')}
          // onFinishFailed={() => console.log('failed')}
          >
            <Tabs
              type="editable-card"
              size='small'
              onChange={onChange}
              activeKey={activeKey}
              onEdit={onEdit}
            >
              {panes.map((pane: any, i: number) => (
                <TabPane tab={'Accepted Payment ' + pane.id} closable={pane.closable} key={pane.id} forceRender={true}>
                  <PageContainer>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="Payment Type"
                          name={`paymenttype-${pane.id}`}
                          rules={[{required:true}]}
                        >
                          <Select allowClear showSearch>
                            {chgPmtData.map((item: optionType) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Use for Guarantee"
                          name={`acceptedforguarnatee-${pane.id}`}
                          rules={[{ required: isRequired ? true : false, message: 'This field is required' }]}
                        >
                          <Select allowClear showSearch>
                            <Option value="Yes">Yes</Option>
                            <Option value="No">No</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Card Type"
                          name={`cardtype-${pane.id}`}
                        >
                          <Select allowClear showSearch>
                            {chgCrdData.map((item: optionType) => <Option value={item.codeName} key={item.codeValue}>{item.codeName}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col span={6}>
                        <Form.Item
                          label="Use for Deposit"
                          name={`usefordeposit-${pane.id}`}
                        >
                          <Select allowClear showSearch>
                            <Option value="Yes">Yes</Option>
                            <Option value="No">No</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          label="Use for Payment"
                          name={`useforpayment-${pane.id}`}
                        >
                          <Select allowClear showSearch>
                            <Option value="Yes">Yes</Option>
                            <Option value="No">No</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={18}>
                        <Form.Item
                          label="Card Description"
                          name={`description-${pane.id}`}
                          rules={[{ max: 128, message: 'You have reached the max character length of 128' }]}
                        >
                          <TextArea maxLength={128} rows={3} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </PageContainer>
                </TabPane>
              ))}
            </Tabs>
          </Form>
        </div>
      </PageContainer>
    </>
  )
})

export default AcceptedPaymentAdd
